/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import {DecisionPoint}  from '@/models/scenario/decision.point';
import {
  WorkBlock,
  WorkType
}                       from '@/models/scenario/work.block';
import {Period}         from '@/util/period';

/**
 *
 * @class WorkBlockChange
 *
 * @brief basic interface for working with the selected work block between the
 * various parts of the work block editor. We don't use an actual work block,
 * because the selection may also be used for adding or editing a row (a work
 * block).  That is we need a change carrier.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2020
 *
 */
export class WorkBlockChange {

  /** the object that caused the selection or edit of this work block */
  public         src: any           = null;

  /** the unique ID for this workblock, at least among work blocks */
  public          id: number        = -1;

  /** user label for block */
  public        name: string        = '';

  public        type: WorkType      = WorkType.NONE;

  /** the west side of the work block */
  public       start: DecisionPoint = null;

  /** the east side of the work block */
  public         end: DecisionPoint = null;

  /** when (time of day) the work starts (in sim time) */
  public       begin: Period        = null;

  /** how long (0..24 hours) the outage is for (in sim time) */
  public    duration: Period        = null;

  /** the days (sim days) where its active */
  public        days: number[]      = [];

  /** user description of work */
  public description: string        = ';';

  /** the actual work block model (for add/clone/delete) */
  
  public       model: WorkBlock     = null;

  /**
   *
   * some changes have to be paired with the current state of the editing panel;
   * this allows us to rollback to states where the editor has transient data; not
   * yet saved to an actual row.
   *
   */

  public snapshot: WorkBlockChange = null;

  /** standard constructor, allow anonymous object initialization */
  public constructor(init?: Partial<WorkBlockChange>) {

    Object.assign(this, init);
  }
}
